import React, { Component } from 'react'
import { InputBase } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import AddNewTeacherComponent from './AddNewTeacherComponent';
import { muiWithStyles, MuiGrid, MuiButton, MuiPaper } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme'
import TeacherCardComponent from './TeacherCardComponent'
import TeacherTitleComponent from './TeacherTitleComponent'
import { AddCircle } from '@material-ui/icons';
import spinner from "../../../ui/icons/spinner.gif"
import '../../../ui/scrollbarForLog.css'


const useStyles = theme => ({
  search: {
    position: 'relative',
    borderRadius: 4,
    marginRight: 16,
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: 24,
      width: 'auto',
    },
  },
  searchIcon: {
    width: 56,
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    paddingTop: 8,
    paddingRight: 8,
    paddingBottom: 8,
    paddingLeft: 8
  },
  button: {
    border: 0,
    background: theme.palette.primary.main,
    borderRadius: '4px',
    color: '#fff',
    cursor: 'pointer',
    font: 'inherit',
    margin: 0,
    outline: 0,
    padding: '12px 20px',
    transition: 'all .1s linear',
    "&:active": {
      boxShadow: '0 2px 0 #006599',
      transform: 'translateY(3px)'
    }
  },


});
export class TeacherComponent extends Component {
  render() {
    if (this.props.updateSchoolinformationInProgress === true) {
      return <img src={spinner} alt="none" style={theme.spinnerImgStyle} />

    }
    const { classes, i18n } = this.props;
    return (
      <MuiGrid container xs={12} direction="row" >
        <TeacherTitleComponent {...this.props} />
        {this.props.showAddNewTeacherComponent ? <AddNewTeacherComponent {...this.props} /> :
          <MuiGrid container xs={12} justify="flex-start" >
            <MuiGrid container xs={10} justify="flex-start" >
              <MuiGrid justify="flex-start" style={{ marginRight: 6 }}>
                <MuiButton id='addButton' onClick={this.props.addNewTeacher} style={theme.primaryButtonStyle} className={classes}>
                  <AddCircle style={{ color: theme.palette.orange, padding: 1 }} />
                  {i18n.teachers.addMoreTeachers}
                </MuiButton>
              </MuiGrid>
              <MuiGrid container xs justify="flex-start" alignItems='center' direction='row'
                style={this.props.activeSchool.school_master !== undefined && this.props.activeSchool.school_master.teachers.length !== 0 ? { border: '1px solid ' + theme.palette.grey.main } :
                  { border: '1px solid ' + theme.palette.grey.main }}>

                <MuiGrid item xs={10} md={11}>
                  <InputBase
                    disabled={this.props.activeSchool.school_master !== undefined && this.props.activeSchool.school_master.teachers.length === 0 ? true : false}
                    id='filterList'
                    onChange={this.props.filterList}
                    style={{ width: '100%' }}
                    placeholder={i18n.teachers.searchField}
                    classes={{
                      root: classes.inputRoot,
                      input: classes.inputInput,
                    }}
                  />
                </MuiGrid>
                <MuiGrid item xs={1}>
                  <SearchIcon style={{ color: theme.palette.grey.darker }} />
                </MuiGrid>
              </MuiGrid>
            </MuiGrid>

            <MuiGrid xs={12} id='scrollStyle' justify="flex-start" style={{ marginTop: '20px', height: '71vh', overflowY: 'auto' }}>

              <MuiGrid container xs={12} direction="row" spacing={2} >

                {this.props.teachers.length > 0 && this.props.teachers.map((teacher, index) => {
                  return (
                    <MuiGrid item xs={12} sm={6} lg={4} id="grid" style={{ display: 'flex', height: 'auto' }}>
                      <TeacherCardComponent
                        {...this.props}
                        teacher={teacher}
                        index={index}
                      />
                      {/* </MuiPaper> */}
                    </MuiGrid>

                  )
                })}
              </MuiGrid></MuiGrid>
          </MuiGrid>}
      </MuiGrid>
    )
  }
}

export default muiWithStyles(useStyles)(TeacherComponent)






// Girish Prasad10:42 AM
// https://github.com/onlicar/react-help-desk
// Girish Prasad10:45 AM
// https://pronovix.com/blog/overview-context-sensitive-and-embedded-help-formats siddesh7394@oksbi